export default __webpack_public_path__ + "static/media/bg_master_02.abbf6866.jpg";